import { createContext } from 'react';

export type AbsoluteRouteContextType = {
  currentRoute: string;
  setCurrentRoute: (absoluteRoute: string) => void;
  currentRoutes: { name: string; key: string }[];
  setCurrentRoutes: (currentRoutes: { name: string; key: string }[]) => void;
  params: Record<string, any> | undefined;
  setParams: (params: Record<string, any> | undefined) => void;
  labels: Record<string, string>;
  setLabels: (labels: Record<string, string>) => void;
};

export const AbsoluteRouteContext = createContext<AbsoluteRouteContextType>({
  currentRoute: '',
  setCurrentRoute: () => {},
  currentRoutes: [],
  setCurrentRoutes: () => {},
  params: undefined,
  setParams: () => {},
  labels: {},
  setLabels: () => {},
});
